import React from 'react'
import ErrorPageType from 'common/src/vtj/ErrorPageType.enum'
import ErrorPage from 'todistukset-ui/src/vtj/components/error-page/ErrorPage.react'

export interface NotFoundErrorProps {
  lang: string
}

export default class NotFoundError extends React.Component<NotFoundErrorProps> {
  render(): React.JSX.Element {
    const { lang } = this.props
    return <ErrorPage errors={[ErrorPageType.PAGE_NOT_FOUND]} lang={lang} />
  }
}
